<template>
	<div v-if="dataInfo.is_show == 1" :style="{ background, paddingTop, }" class="Partners">
		<div class="PartnersWidth">
			<indexTitle :title="dataInfo.moduleTitle" :more="showMore" @goMore="goMore"></indexTitle>
			<div class="imageBox">
				<img :key="item.id" v-for="item in dataInfo.list" :src="item.cover" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import indexTitle from "@/components/c/indexTitle.vue"
export default {
	components: {
		indexTitle,
	},
	props: {
		background: {
			type: String,
			default: '#ffffff',
		},
		paddingTop: {
			type: String,
			default: '0px',
		},
		showMore: {
			type: Boolean,
			default: true,
		},
		dataInfo: {
			type: Object,
			default: () => {
				return {
					is_show: 2,
					list: [],
					moduleTitle: '',
				}
			},
		},
	},
	data() {
		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {
		goMore() {
			let lang = this.$i18n.locale == 'zh' ? 'cn' : 'en'
			this.$router.push({
				path: `/${lang}/partners`,
			})
		}
	}
}
</script>

<style scoped lang="scss">
.Partners {
	background: #ffffff;
	padding-top: 0px;
	padding-bottom: 116px;

	.PartnersWidth {
		width: 1200px;
		margin: auto;

		.imageBox {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-top: 80px;

			img {
				width: 380px;
				height: 200px;
				margin-bottom: 30px;
				object-fit: cover;
				display: block;
			}
		}
	}
}

@media screen and (max-width:1200px) {
	.Partners {

		.PartnersWidth {
			width: 100%;
			margin: auto;

			.imageBox {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-top: 80px;

				img {
					width: calc((100% - 30px) / 2);
					height: auto;
					aspect-ratio: 38/20;
				}
			}
		}
	}

}
</style>